import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { List } from 'antd';

import { APPLICATIONS_RENDER, APPLICATIONS_RENDER_ENG } from 'entities/application/constants';
import { Application } from 'entities/application/types';
import { ApplicationsListItem } from '../ApplicationsListItem/ApplicationsListItem';
import { ApplicationsListSectionStyled, ApplicationsListStyled, ListHeadingStyled } from './ApplicationsList.styles';

const renderApplication = (application: Application): JSX.Element => (
	<List.Item>
		<ApplicationsListItem application={application} />
	</List.Item>
);

export const ApplicationsList: React.FC = () => {
	const { t, i18n } = useTranslation();

	useEffect(() => {
		document.title = `Marketplace`;
	}, []);

	const applications = i18n.language === `ru-RU` ? APPLICATIONS_RENDER : APPLICATIONS_RENDER_ENG;

	return (
		<ApplicationsListSectionStyled>
			<ListHeadingStyled>{t(`Marketplace_Application_Catalog`)}</ListHeadingStyled>
			{/* <ApplicationsListGridStyled>
			{APPLICATIONS_RENDER.map(n => {
				renderApplication(n)
			})}
		</ApplicationsListGridStyled> */}
			<ApplicationsListStyled
				grid={{
					gutter: 24,
					xs: 2,
					sm: 2,
					md: 2,
					lg: 3,
					xl: 4,
					xxl: 4,
				}}
				dataSource={applications}
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				// FIXME
				renderItem={renderApplication}
			/>
		</ApplicationsListSectionStyled>
	);
};
